module.exports = __webpack_public_path__ + "static/media/logo_base-line.c951214b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_base-line.png
// module id = 200
// module chunks = 0